import React, { useEffect, useState, Suspense, lazy } from "react";
import Header from "../Header/index";
import localJsonData from "./testimonials.json";  
import "./MainPage.css";

// Lazy load components
const MovingGradients = lazy(() => import("../MovingGradient/index"));
const Banner = lazy(() => import("../Banner/Banner.js"));
const TestimonialsBlog = lazy(() => import("../TestimonialsBlog/index"));
const BannerVideoSection = lazy(() => import("../BannerVideoSection/BannerVideoSection"));
const ReviewsSection = lazy(() => import("../ReviewsSection/index"));
const JourneySection = lazy(() => import("../JourneySection/index"));
const Footer = lazy(() => import("../Footer/index"));
const Disclaimers = lazy(() => import("../Disclaimers/index"));

export default function MainPage() {
  const cdnUrl = process.env.REACT_APP_CDN_PATH;
  const [showBelowFold, setShowBelowFold] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [jsonData, setJsonData] = useState(localJsonData); // Start with local data immediately

  // Fetch JSON from S3 in background
  useEffect(() => {
    const fetchJsonData = async () => {
      try {
        const response = await fetch(`${cdnUrl}testimonials.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setJsonData(data); // Silently update when ready
      } catch (error) {
        console.warn("Failed to fetch JSON from S3, using local fallback:", error);
        // Already using localJsonData, so no action needed
      }
    };
    fetchJsonData();
  }, [cdnUrl]);

  // Remove the loading state and LoadingSpinner entirely!

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener("resize", handleResize);

    const handleTriggerBelowFold = () => {
      setShowBelowFold(true);
    };
    window.addEventListener("triggerBelowFold", handleTriggerBelowFold);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("triggerBelowFold", handleTriggerBelowFold);
    };
  }, []);

  useEffect(() => {
    if (window.innerHeight > 1000) {
      setShowBelowFold(true);
      return;
    }
    const handleScroll = () => {
      setShowBelowFold(true);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true,
      once: true,
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="angel-rewards-page">
      <Header />
      
      <Suspense fallback={<div style={{ minHeight: "800px" }} />}>
        <Banner data={jsonData} cdnUrl={cdnUrl} />
      </Suspense>
      
      <Suspense fallback={<div style={{ minHeight: "300px" }} />}>
        <TestimonialsBlog data={jsonData} cdnUrl={cdnUrl} />
      </Suspense>
       
      <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
        <MovingGradients />
      </Suspense>
        
      {showBelowFold && (
        <>
          <Suspense fallback={<div style={{ minHeight: "500px" }} />}>
            <BannerVideoSection data={jsonData} cdnUrl={cdnUrl}/>
          </Suspense>
          
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            <ReviewsSection data={jsonData} cdnUrl={cdnUrl} />
          </Suspense>
          
          <JourneySection data={jsonData} />
          
          <Suspense fallback={<div style={{ minHeight: "400px" }} />}>
            <Disclaimers data={jsonData} cdnUrl={cdnUrl} />
          </Suspense>
          
          <Suspense fallback={<div style={{ minHeight: "200px" }} />}>
            <Footer />
          </Suspense>
        </>
      )}
    </div>
  );
}
